/*
 * Copyright (C) 2021 Corsair M360, Inc - All Rights Reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited.
 *  Proprietary and confidential.
 */

export default {
	namespaced: true,
	
	state: {
		images: {}
	},
	
	mutations: {
		
		//set or clear user
		set( state, value ) {
			state.images[value.name] = value.value;
		}
	},
	
	actions: {
		set( { commit }, value ) {
			commit( 'set', value );
		},
	},
	
	getters: {
		get:(state) => (name) => {
			return state.images[name];
		}
	}
}
